import React, { useEffect, useState } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, FormGroup
} from "@/design-system/native";
import { CheckCircle, X } from 'lucide-react';
import { Select } from "@/design-system/components/Select";
import styles from "./TodoEditModal.module.scss";

const TodoEditModal = ({ isOpen, toggle, todo, onSave, labelOptions = [] }) => {
  const [title, setTitle] = useState(todo?.title || '');
  const [description, setDescription] = useState('');
  const [labels, setLabels] = useState([]);
  const [date, setDate] = useState('');

  useEffect(() => {
    setTitle(todo?.title || '');
    setDescription(todo?.description || '');
    setLabels(todo?.labels || []);
    setDate(todo?.date || '');
  }, [todo]);

  const handleSave = () => {
    onSave({ ...todo, title, description, labels, date });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{todo ? "Edit" : "Add to do"}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title"
            autoFocus
          />
        </FormGroup>
        <FormGroup>
          <Input
            type="textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description..."
            rows="4"
          />
        </FormGroup>
        <FormGroup>
          <Select
            isMulti
            options={labelOptions}
            value={labelOptions.filter((o) =>
              (labels || []).includes(o.value)
            )}
            onChange={(selected) =>
              setLabels((selected || []).map((o) => o.value ?? o.label ?? o))
            }
            placeholder="Labels"
          />
        </FormGroup>
        <FormGroup>
          <Input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            placeholder="Date"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          <X className={styles.btnIcon} /> Close
        </Button>
        <Button color="primary" onClick={handleSave}>
          <CheckCircle className={styles.btnIcon} /> Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TodoEditModal;
